import Swiper from 'swiper/bundle';

export default function blockLogotypes() {
    document.querySelectorAll(
        '.block-logotypes' ).
        forEach( function( block ) {

        const slider = block.querySelector('.logotypes-slider');


            const swiper2 = new Swiper( slider,{
                speed: 1000,
                loop: true,
                spaceBetween: 2,
                autoplay: {
                    delay: 4000,
                    disableOnInteraction: true,
                },
                navigation: {
                    nextEl: block.querySelector('.slider__arrows .slider__arrow--next'),
                    prevEl: block.querySelector('.slider__arrows .slider__arrow--prev'),
                },
                breakpoints: {
                    0: {
                        slidesPerView: 1,
                    },
                    768: {
                        slidesPerView: Math.ceil( parseInt( slider.dataset.cols ) / 2 ),
                        loopAdditionalSlides: 0,
                    },
                    // when window width is >= 480px
                    1200: {
                        slidesPerView: parseInt( slider.dataset.cols ),
                    },
                },
            } );
        } );
}